import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const FireState = (props) => {
  const FireStateSVG = () => {
    const themeDefault = useSelector((state) => state.themeDefault);

    const predefinedSizes = {
      small: themeDefault?.info?.newConfig?.emptyStateSizes?.small,
      medium: themeDefault?.info?.newConfig?.emptyStateSizes?.medium,
      large: themeDefault?.info?.newConfig?.emptyStateSizes?.large,
    };

    return (
      <svg
        width={predefinedSizes[props?.size] || 150}
        height={predefinedSizes[props?.size] || 150}
        viewBox="0 0 150 150"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_1593_21697)">
          <path
            opacity="0.02"
            d="M120 53.6699V135.5C107.036 145.278 91.2387 150.568 75 150.568C58.7613 150.568 42.9645 145.278 30 135.5V53.6699C34.2435 53.6699 38.3131 51.9842 41.3137 48.9836C44.3143 45.983 46 41.9134 46 37.6699H104C104 41.9134 105.686 45.983 108.686 48.9836C111.687 51.9842 115.757 53.6699 120 53.6699Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            opacity="0.08"
            d="M150 75.3999C150.01 87.0451 147.304 98.5321 142.096 108.948C136.888 119.364 129.322 128.421 120 135.4V53.3999C115.757 53.3999 111.687 51.7142 108.686 48.7136C105.686 45.713 104 41.6434 104 37.3999H46C46 41.6434 44.3143 45.713 41.3137 48.7136C38.3131 51.7142 34.2435 53.3999 30 53.3999V135.4C19.7726 127.729 11.6757 117.572 6.47817 105.892C1.28063 94.2118 -0.845023 81.3971 0.303074 68.6645C1.45117 55.9319 5.8349 43.7041 13.038 33.1423C20.2411 22.5805 30.0244 14.0352 41.459 8.31787C52.8936 2.60058 65.5998 -0.0989146 78.3711 0.475715C91.1425 1.05034 103.555 4.88003 114.43 11.6011C125.305 18.3222 134.281 27.7115 140.507 38.8776C146.732 50.0436 150 62.6157 150 75.3999Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            d="M75 54.3999C70.2533 54.3999 65.6131 55.8075 61.6663 58.4446C57.7195 61.0818 54.6434 64.8301 52.8269 69.2155C51.0104 73.6009 50.5351 78.4265 51.4612 83.0821C52.3872 87.7376 54.673 92.014 58.0294 95.3705C61.3859 98.7269 65.6623 101.013 70.3178 101.939C74.9734 102.865 79.799 102.39 84.1844 100.573C88.5698 98.7565 92.3181 95.6804 94.9553 91.7336C97.5924 87.7868 99 83.1467 99 78.3999C99 72.0347 96.4714 65.9302 91.9706 61.4293C87.4697 56.9285 81.3652 54.3999 75 54.3999ZM79.12 95.7699C75.872 96.8538 72.3301 96.6351 69.24 95.1599C67.8624 94.4695 66.637 93.5104 65.6357 92.3391C64.6345 91.1679 63.8777 89.8081 63.41 88.3399C61.41 83.0599 62.99 78.1499 67.06 74.5599C67.94 73.7899 68.76 74.0599 69.06 75.2099C69.4171 76.6633 70.0745 78.0259 70.99 79.2099C70.6889 77.649 70.4687 76.0735 70.33 74.4899C70.22 72.449 70.613 70.4123 71.4743 68.5588C72.3357 66.7053 73.6391 65.0918 75.27 63.8599C75.98 63.2699 76.78 62.7699 77.55 62.2499C77.7572 62.0577 78.0238 61.942 78.3056 61.922C78.5875 61.902 78.8678 61.9789 79.1 62.1399C79.3013 62.3134 79.4426 62.5461 79.5036 62.8047C79.5647 63.0634 79.5424 63.3347 79.44 63.5799C79.1464 64.8916 79.0454 66.2391 79.14 67.5799C79.14 68.0799 79.24 68.5799 79.33 69.0799C79.7107 71.367 80.8822 73.448 82.64 74.9599C84.107 76.1624 85.3205 77.6445 86.21 79.3199C86.42 79.7399 86.6 80.1699 86.76 80.5899C86.7645 80.6264 86.7645 80.6634 86.76 80.6999C87.2727 82.1899 87.4809 83.7677 87.3724 85.3397C87.2639 86.9116 86.8408 88.4458 86.1283 89.8513C85.4158 91.2567 84.4283 92.5048 83.2245 93.5214C82.0206 94.5381 80.6249 95.3027 79.12 95.7699Z"
            fill={themeDefault?.info?.colorPrimary}
          />
          <path
            opacity="0.16"
            d="M91 111.4C91 112.196 90.6839 112.959 90.1213 113.521C89.5587 114.084 88.7957 114.4 88 114.4H62C61.2044 114.4 60.4413 114.084 59.8787 113.521C59.3161 112.959 59 112.196 59 111.4C59 110.604 59.3161 109.841 59.8787 109.279C60.4413 108.716 61.2044 108.4 62 108.4H88C88.7957 108.4 89.5587 108.716 90.1213 109.279C90.6839 109.841 91 110.604 91 111.4ZM97 120.4H53C52.2044 120.4 51.4413 120.716 50.8787 121.279C50.3161 121.841 50 122.604 50 123.4C50 124.196 50.3161 124.959 50.8787 125.521C51.4413 126.084 52.2044 126.4 53 126.4H97C97.7957 126.4 98.5587 126.084 99.1213 125.521C99.6839 124.959 100 124.196 100 123.4C100 122.604 99.6839 121.841 99.1213 121.279C98.5587 120.716 97.7957 120.4 97 120.4Z"
            fill={themeDefault?.info?.colorPrimary}
          />
        </g>
        <defs>
          <clipPath id="clip0_1593_21697">
            <rect
              width="150"
              height="150.13"
              fill="white"
              transform="translate(0 0.399902)"
            />
          </clipPath>
        </defs>
      </svg>
    );
  };
  return <Icon component={FireStateSVG} />;
};

export default FireState;
